module.exports = __webpack_public_path__ + "static/media/ALIANZA BRA-04.97371702.png";